export function requestRefetch(refetch) {
  if(this.state.requestRefetch) {
    refetch();
    this.state.requestRefetch = false;
    this.setState(this.state);
  }
}
